module.exports = __webpack_public_path__ + "src/img/redchair.png?1370bdc0134173f7ecf943f9d4c0e583";


//////////////////
// WEBPACK FOOTER
// ./src/img/redchair.png
// module id = 197
// module chunks = 0